import { useEffect } from "react";
import { useKeyboardStateStore } from "../store/keyboardStateStore";
import { addEventListenerAllWindows } from "~/utils/popoutWindowsRegistry";

/**
 * Hook to track modifier key releases globally.
 *
 * This hook listens for keyup events on modifier keys (Shift, Control, Meta)
 * and arms them in the keyboard state store, allowing one-click trading orders
 * to be placed again.
 *
 * Usage: Call this hook once in a parent component (e.g., ChartWrapper) to
 * enable global modifier key tracking for one-click trading.
 */
export const useModifierKeyTracking = () => {
  const armKey = useKeyboardStateStore((s) => s.armKey);

  useEffect(() => {
    const handleKeyUp = (e) => {
      // Check both e.key and e.code for cross-platform compatibility
      // On Mac, Command key: e.key='Meta', e.code='MetaLeft'/'MetaRight'
      if (
        e.key === "Shift" ||
        e.code === "ShiftLeft" ||
        e.code === "ShiftRight"
      ) {
        armKey("Shift");
      }
      if (
        e.key === "Control" ||
        e.code === "ControlLeft" ||
        e.code === "ControlRight"
      ) {
        armKey("Control");
      }
      if (e.key === "Meta" || e.code === "MetaLeft" || e.code === "MetaRight") {
        armKey("Meta");
      }
    };

    // Every window (PoC #popout) — releasing a modifier over a popout must re-arm too
    const detach = addEventListenerAllWindows("keyup", handleKeyUp);
    return detach;
  }, [armKey]);
};
